export const Accomodation = [
    { name: 'YES', code: true },
    { name: 'NO', code: false },
]